// 时间过滤器
let timeAllfilters = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '年' + month + '月' + day + '日' + ' ' + hours + ':' + min + ':' + sec;
        return times;
    }
}

let timePointfilters = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let times = d.getFullYear() + '.' + month + '.' + day;
        return times;
    }
}

let timefilters = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let times = d.getFullYear() + '年' + month + '月' + day + '日';
        return times;
    }
}

// 秒值转字符串
let timeToString = function(param) {
    param = parseInt(param)
    let hh = '',
        mm = '',
        ss = ''
    if (param >= 0 && param < 60) {
        param < 10 ? (ss = '0' + param) : (ss = param)
        return '00:' + ss
    } else if (param >= 60 && param < 3600) {
        mm = parseInt(param / 60)
        mm < 10 ? (mm = '0' + mm) : mm
        param - parseInt(mm * 60) < 10 ?
            (ss = '0' + String(param - parseInt(mm * 60))) :
            (ss = param - parseInt(mm * 60))
        return mm + ':' + ss
    }
}

let timeYear = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        return d.getFullYear();
    }
}

let timeMonth = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        return month;
    }
}

let timeDay = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        return day;
    }
}

let strToDate = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        var s = val.split('-')
        return s[0] + "年" + s[1] + "月" + s[2] + "日"
    }
}

let strToYear = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        var s = val.split('-')
        return s[0]
    }
}

let strToDay = function(val) {
    if (val == null || val == "") {
        return;
    } else {
        var s = val.split('-')
        return s[2]
    }
}

export { timefilters, timeToString, timeYear, timeMonth, timeDay, timePointfilters, timeAllfilters, strToDate, strToYear, strToDay }


// WEBPACK FOOTER //
// ./src/utils/filter.js